import { Link } from 'react-router-dom';
import { AdminLayout } from '../components/admin-layout';
import { Card } from '../components/ui';

const settings = [
  {
    label: 'Identitas Lembaga',
    description: 'Nama, logo, alamat, kontak lembaga.',
    to: '/settings/institution',
  },
  { label: 'Sekolah', description: 'Master sekolah.', to: '/master/sekolah' },
  { label: 'Jabatan', description: 'Master jabatan.', to: '/master/jabatan' },
  {
    label: 'Tarif Honor',
    description: 'Pengaturan tarif honor pegawai.',
    to: '/master/honor-pegawai',
  },
  {
    label: 'Insentif Kegiatan',
    description: 'Insentif kegiatan dinamis untuk honorarium.',
    to: '/master/insentif-kegiatan',
  },
  {
    label: 'Jenis Komponen Honor',
    description: 'Master jenis komponen penyusun honorarium.',
    to: '/master/jenis-komponen-honor',
  },
  {
    label: 'Konfigurasi Honor Jabatan',
    description: 'Tarif honor jabatan temporal (berlaku mulai - sampai).',
    to: '/master/konfigurasi-honor-jabatan',
  },
  {
    label: 'Total JP Mengajar',
    description: 'Data total jam pelajaran mengajar per pegawai.',
    to: '/honorarium/total-jp-mengajar',
  },
  { label: 'Periode Absensi', description: 'Pengaturan periode absensi.', to: '/absensi/periode' },
  { label: 'Kalender Kerja', description: 'Pengaturan kalender kerja.', to: '/absensi/kalender' },
  {
    label: 'Pengaturan Sistem',
    description: 'Konfigurasi global aplikasi (key-value).',
    to: '/admin/system-settings',
  },
  {
    label: 'Matriks Permission',
    description: 'Matriks permission baseline V1 (read-only).',
    to: '/admin/permissions',
  },
  { label: 'Audit Log', description: 'Explorer audit log dengan filter.', to: '/admin/audit-log' },
  {
    label: 'Persetujuan Akun',
    description: 'Verifikasi & persetujuan registrasi akun baru.',
    to: '/admin/pending-users',
  },
  {
    label: 'Manajemen Akun',
    description: 'Reset password & unlock akun pegawai.',
    to: '/admin/akun',
  },
  {
    label: 'Role Pegawai',
    description: 'Manajemen role assignment pegawai (temporal).',
    to: '/admin/pegawai-roles',
  },
] as const;

export function PengaturanPage() {
  return (
    <AdminLayout title="Pengaturan">
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '1rem',
        }}
      >
        {settings.map((item) => (
          <Card key={item.to} style={{ border: '1px solid #E2E8F0', boxShadow: 'none' }}>
            <h2 style={{ margin: 0, fontSize: '1rem' }}>{item.label}</h2>
            <p style={{ color: '#475569', fontSize: '0.875rem' }}>{item.description}</p>
            <Link to={item.to} style={{ color: '#1D4ED8', fontWeight: 600 }}>
              Buka
            </Link>
          </Card>
        ))}
      </div>
    </AdminLayout>
  );
}
